// Basic validation for Reply.user_generic_id (passport / national ID).
// Mirrors backend rules in talentapp/serializers.py::validate_generic_id.

const ALLOWED_RE = /^[A-Za-z0-9 .\-/]+$/;
const HAS_ALNUM_RE = /[A-Za-z0-9]/;
const MIN_LENGTH = 6;

// Returns null if valid, otherwise an i18n key describing the problem.
export function validateGenericId(value) {
    const v = (value || '').trim();
    if (v.length < MIN_LENGTH) return 'generic_id_too_short';
    if (!ALLOWED_RE.test(v)) return 'generic_id_invalid_chars';
    if (!HAS_ALNUM_RE.test(v)) return 'generic_id_invalid_chars';
    return null;
}
